import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IState, auditLogFeatureKey } from './audit-log.reducers';
import { createQueryParamsWithPagination } from '../../../shared/utils';
import { IAuditLogFilter } from './audit-log.interface';

const selectFeature = createFeatureSelector<IState>(auditLogFeatureKey);

const selectAuditLogs = createSelector(
	selectFeature,
	(state) => state.auditLogs,
);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectError = createSelector(selectFeature, (state) => state.error);

const selectAuditLogFilter = createSelector(
	selectFeature,
	(state) => state.filter,
);

const selectAuditLogFilterRequest = createSelector(
	selectAuditLogFilter,
	(state) => createQueryParamsWithPagination<IAuditLogFilter>(state),
);

export const AuditLogSelectors = {
	selectAuditLogs,
	selectLoading,
	selectError,
	selectAuditLogFilter,
	selectAuditLogFilterRequest,
};
